import styled from 'styled-components';
import {
  // COLOR, FONT 
} from 'assets';

export const GenreDetailContainerStyled = styled.div`
  /*===============================================
 Container 
===============================================*/

  /*===============================================
Theme 
===============================================*/
  margin: 20px 15px;
  .form_item_layout {
    max-width: 900px;
    margin: auto;
    margin-bottom: 30px;
    &.last {
      margin-bottom: 0px;
    }
    .shwo_agency_layout {
      margin-top: 30px;
      .show_agent_detail {
        cursor: pointer;
        text-decoration: underline;
        color: #0059b3;
      }
    }
  }
`;
